import { render, staticRenderFns } from "./ForgotPasswordView.vue?vue&type=template&id=50c07f37&scoped=true"
import script from "./ForgotPasswordView.vue?vue&type=script&lang=ts"
export * from "./ForgotPasswordView.vue?vue&type=script&lang=ts"
import style0 from "./ForgotPasswordView.vue?vue&type=style&index=0&id=50c07f37&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c07f37",
  null
  
)

export default component.exports